module.exports = __webpack_public_path__ + "img/up-arrow.ec38e80f.svg";